



























































import _ from 'lodash'
import moment from 'moment'
import { Component, Prop } from 'vue-property-decorator'
import VueExtendedBaseComponent from '@/VueExtendedBaseComponent.vue'
import { IScheduleLog } from '@/store/modules/views/schedule/states'

@Component
export default class DetailLog extends VueExtendedBaseComponent {
  @Prop() public title!: string
  @Prop() public detail!: IScheduleLog
  @Prop() private open!: boolean

  private zoomImageDialog = false
  private imageSrc = ''

  get createJobDialogOption() {
    return {
      justify: 'start',
      button: {
        justify: 'center',
        cancelButton: {
          title: 'ปิด',
          action: this.closeDialog,
          height: '30',
        },
      },
    }
  }

  // get detailGrouping() {
  //   return this.detail && this.detail.logs && this.detail.logs.length > 0
  //     ? _(this.detail.logs)
  //         .map((item) => {
  //           return {
  //             ...item,
  //             createdAt: this.doConvertDate(item.createdAt),
  //             createdTime: this.doConvertTime(item.createdAt),
  //             groupName: `${this.doConvertDate(item.createdAt)}_${this.doConvertTime(item.createdAt)}`,
  //           }
  //         })
  //         .orderBy(['groupName'], ['desc'])
  //         .uniqBy('groupName')
  //         .groupBy('groupName')
  //         .value()
  //     : undefined
  // }

  get openDialog() {
    return this.open
  }

  set openDialog(value: boolean) {
    this.$emit('update:open', value)
  }

  private closeDialog() {
    this.$emit('update:open', false)
  }

  private openZoomImageDialog(imgeSrc: string, modelDialog: 'zoomImageDialog') {
    this[modelDialog] = true
    this.imageSrc = imgeSrc
  }

  private doConvertDate(date) {
    return moment.unix(date).locale('th').add(543, 'year').format('DD MMMM YYYY')
  }

  private doConvertTime(time) {
    return moment.unix(time).locale('th').add(543, 'year').format('HH:mm')
  }
}
